import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
};

const signupClienteFinalSlice = createSlice({
  name: "authentication/signupClienteFinal",
  initialState,
  reducers: {
    submitSignupClienteFinalInited: {
      prepare: (props) => ({ payload: { props } }),
      reducer: () => ({ ...initialState, isLoading: true }),
    },
    submitSignupClienteFinalCompleted: {
      prepare: () => ({ payload: {} }),
      reducer: () => ({ ...initialState, isLoading: false }),
    },
    submitSignupClienteFinalFailed: {
      prepare: (error) => ({ payload: { error } }),
      reducer: () => ({ ...initialState, isLoading: false }),
    },
  },
});

const {
  submitSignupClienteFinalInited,
  submitSignupClienteFinalCompleted,
  submitSignupClienteFinalFailed,
} = signupClienteFinalSlice.actions;

const submitSignupClienteFinal = (userName, onComplete) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(submitSignupClienteFinalInited({ userName }));
      await services.api.postSignupClienteFinal({
        NombreUsuario: userName,
      });
      dispatch(submitSignupClienteFinalCompleted());
      onComplete();
    } catch (error) {
      console.error(error);
      dispatch(submitSignupClienteFinalFailed(error));
    }
  };
};

export default signupClienteFinalSlice.reducer;
export { submitSignupClienteFinal };
